import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageSOPManagementService {
  /**
   * Whether the _old_ SOP step editor popup is opened. (Naming is incorrect: false = collapsed (hidden), true = shown)
   * TODO obsolete: Remove component PhBhpSopStepComponent and this field
   */
  isCollapsed = false;
  getSopList = new Subject();
  imageUploadedFromMobile = new Subject();
  subStepDisable = false;
  checkUpdate = false;
  constructor(private service: PHBHPApiService) { }

  getHandDisinfectionIndicators() {
    return this.service.getApi('SOPs/GetHandDisinfectionIndicators', true);
  }
  createSOP(data) {
    return this.service.postApi(`SOPManage/CreateSOP/${data}`, undefined, true);
  }
  getSOPs() {
    return this.service.getApi('SOPs/GetSOPs', true);
  }
  getSOPDetails(userId, institutionId, status?) {
    status = status ? status : 'all';
    return this.service.getApi(`SOPManage/GetSOPDetails/${userId}/${institutionId}/${status}`, true);
  }
  getSOPById(Id) {
    return this.service.getApi('SOPs/GetSOPById/' + Id, true);
  }
  getSopVersionsImages(Id) {
    return this.service.getApi('SOPs/GetSopVersionsImages/' + Id, true);
  }
  InstitutionImageUploader(Id) {
    return this.service.getApi( `InstitutionImageUploader/${Id}`, true);
  }
  InstitutionAdminImageUploader(Id,roleId) {
    if (roleId == 3) {
      return this.service.getApi(`InstitutionImageUploader/GetImageLibrarysByGroupId/${Id}`, true);
    }
    else {
      return this.service.getApi(`InstitutionImageUploader/GetImageLibraryDetailByInstitutionIds/${Id}`, true);
    }
  }
  updateSOP(Id, data) {
    return this.service.putApi('SOPs/UpdateSOP/' + Id, data, true);
  }
  PublishSOP(Id, userId, data) {
    return this.service.putApi(`SOPs/PublishSOP/${Id}/${userId}`, data, true);
  }
  getImageLibraries() {
    return this.service.getApi(`ImageUploader`, true);
  }
  getSOPCountriesList() {
    return this.service.getApi(`SOPManage/GetSOPCountriesList`, true);
  }
  getUsersInstitutions(userId, roleId) {
    return this.service.getApi(`ManageInstitution/GetUsersInstitutions/${userId}/${roleId}`, true);
  }
  deleteSOP(sopId, userId) {
    return this.service.deleteApi(`SOPObservation/DeletedSOPObservations/${sopId}/${userId}`, true);
  }
  deleteSOPDraft(sopId, userId) {
    return this.service.deleteApi(`SOPs/DeleteSOP/${sopId}/draft`, true);
  }
  getBlobImageStream(url) {
    return this.service.getApi('Blob?path='+url, true);
  }
  getTranslationsFromKey(key) {
    return this.service.getApi(`sop/translation/${key}`, true)
  }
  patchTranslation(key: string, request: any) {
    return this.service.patchApi(`sop/translation/${key}`, request, true)
  }
  getPublishedTranslation(sopId: number, query: string) {
    return this.service.getApi(`sop/translation/published/${sopId}?${query}`, true)
  }
  duplicateSOP(sopId: number, userId: number, stepVersionID: number, institutionId: number, isMaster: boolean , countryId: number = 0) {
    return this.service.postApi(`SOPManage/DuplicateSOP/${sopId}/${userId}/${stepVersionID}/${institutionId}/${isMaster}`, undefined, true);
  }
  getTranslationsForSop(sopId: number, version: number) : Observable<Translations> {
    return this.service.getApi(`Translation/sop/${sopId}/${version}`,true);
  }
  reloadTranslationsByIds(listofSOPID) {
    return this.service.getApi(`sop/translationsBySOPID/${listofSOPID}`,true);
  }
}

export interface Translations {
  [language: string] : TranslationEntries;
}

export interface TranslationEntries {
  [key: string]: string;
}
